module.exports = __webpack_public_path__ + "img/icon_liebiaomoshi.557be12e.svg";